import { createSelector } from 'reselect'
import { mapSlider } from 'api-data-io/cms/slider'
import { isEmpty } from 'helpers/utils'

const getSliders = state => state.sliders

export const getSlidersData = createSelector(
  [getSliders],
  sliders => (sliders ? sliders.data : [])
)

export const getMainSlidersData = createSelector(
  [getSlidersData],
  sliders => {
    const new_sliders = {
      activeIds:[],
      data:[]
    };

    (sliders || [])
      .filter(slider => slider.showSlider && !isEmpty(slider.mainSliderReference))
      .map(slider => new_sliders.activeIds.push(slider.nid)
        && (slider.mainSliderReference || []).map(mainSlider => mapSlider(mainSlider)))
      .forEach(mainSlider => new_sliders.data.push(...mainSlider))

    return new_sliders
  }
)
